import { observer } from 'mobx-react-lite'
import { AlertBanner, EnumAlertBannerVariant } from 'shared/ui'
import { uiStore } from 'shared/store/uiStore'
import { BillingPath } from 'entities/ExportRouters'
import { useEntitiesContext } from 'entities/EntitiesExport'

export const CanceledSubscriptionBanner = observer(() => {
  const { subscriptionStore } = useEntitiesContext()

  if (!subscriptionStore.isCanceled) return null
  if (!uiStore.location) return null

  const { pathname } = uiStore.location
  const isClientsPage = pathname === '/clients' || pathname.startsWith('/clients/')

  if (!isClientsPage) return null

  return (
    <AlertBanner
      ariaLabel={'CanceledSubscription'}
      title={'Your subscription has been canceled.'}
      variant={EnumAlertBannerVariant.Error}
      actionPrimary={{
        text: 'Restart Subscription',
        onAction: () => {
          uiStore.changeRouteViaVue({
            path: `/${BillingPath.upgrade}`,
          })
        },
      }}
    />
  )
})
